module.exports = __webpack_public_path__ + "static/media/IMG_2726.c891a13f.JPG";